import React from "react";
import { IconProps } from "./icons.models";

export const DownlineIcon: React.FC<IconProps> = ({
    width = 14,
    height = 12,
    className,
    onClick,
    fillColor = "black",
}) => (
    <svg
        width={width}
        height={height}
        viewBox="0 0 14 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        onClick={onClick}
    >
        <path
            d="M9.44518 11.53H13.3052V7.67H11.7027V5.5025H6.98018V3.8575H8.58268V0L4.72268 0V3.86H6.32518V5.505L1.60268 5.505V7.6725H0.000175476V11.53H3.86018V7.67H2.25768V6.1575L11.0477 6.1575V7.67H9.44518V11.53ZM12.6502 8.325V10.875H10.1002V8.325H12.6502ZM5.37768 3.205V0.655L7.92768 0.655V3.205H5.37768ZM3.20518 8.325V10.875H0.655175V8.325H3.20518Z"
            fill={fillColor}
        />
    </svg>
);
